import { serverInfo } from '../config/serverConfig';
import { getAuthHeaders } from './authHeaders';

const base = serverInfo.serverUrl;

/**
 * @param {{ account_id: string }} body
 * @returns {{ success: boolean, account_id: string, items: Array<{ id: string, label: string, description: string, count: number|null, details: object, resettable: boolean }> }}
 */
export async function fetchUserCustomizationSummary(body) {
  const headers = await getAuthHeaders();
  const res = await fetch(base + '/userCustomization/summary', {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to load summary');
  return data;
}

/**
 * @param {{ account_id: string, type: string, performed_by?: string }} body
 * @returns {{ success: boolean, type: string, deletedCount: number }}
 */
export async function resetUserCustomizationType(body) {
  const headers = await getAuthHeaders();
  const res = await fetch(base + '/userCustomization/reset', {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Reset failed');
  return data;
}
